<div class="flex items-center pb-6 justify-between">
	<div class="flex">
		<activar-button
			[disabled]="currentPage() === 0"
			(click)="changePage(currentPage() - 1)"
			fill="out"
			color="default">
			<div
				class="flex flex-row justify-between items-center w-full gap-2">
				<activar-icon name="arrow_left" size="15px"> </activar-icon>
				<p class="hidden md:block">Anterior</p>
			</div>
		</activar-button>
	</div>

	<div class="flex gap-2">
		@if (this.windowSize === 1) {
			<button
				(click)="changePage(currentPage())"
				[class.current]="true"
				class="page__button">
				{{ currentPage() + 1 }}
			</button>
		} @else {
			@if (pages(); as pages) {
				@if (pages[0] > 0) {
					<button
						(click)="changePage(0)"
						[class.current]="currentPage() === 0"
						class="page__button">
						{{ 1 }}
					</button>
				}
				@if (pages[0] > 1) {
					<div>...</div>
				}

				@for (page of pages; track page) {
					<button
						(click)="changePage(page)"
						[class.current]="currentPage() === page"
						class="page__button">
						{{ page + 1 }}
					</button>
				}

				@if (pages[pages.length - 1] < totalPages() - 2) {
					<div>...</div>
				}

				@if (pages[pages.length - 1] < totalPages() - 1) {
					<button
						(click)="changePage(totalPages() - 1)"
						[class.current]="currentPage() === totalPages() - 1"
						class="page__button">
						{{ totalPages() }}
					</button>
				}
			}
		}
	</div>
	<div class="flex">
		<activar-button
			[disabled]="currentPage() === totalPages() - 1"
			(click)="changePage(currentPage() + 1)"
			fill="out"
			color="default">
			<div
				class="flex flex-row justify-between items-center w-full gap-2">
				<p class="hidden md:block">Siguiente</p>
				<activar-icon name="arrow_right" size="15px"> </activar-icon>
			</div>
		</activar-button>
	</div>
</div>
